import { useCallback, useMemo, useState } from 'react';
import {
  getCostPanelTheme,
  getInitialStoreThemeMode,
  saveStoreThemeMode,
} from './storePanelTheme';

export function useStorePanelTheme() {
  const [mode, setMode] = useState(getInitialStoreThemeMode);

  const toggleMode = useCallback(() => {
    setMode((prev) => {
      const next = prev === 'light' ? 'dark' : 'light';
      saveStoreThemeMode(next);
      return next;
    });
  }, []);

  const setThemeMode = useCallback((next) => {
    const safe = next === 'light' ? 'light' : 'dark';
    saveStoreThemeMode(safe);
    setMode(safe);
  }, []);

  const ui = useMemo(() => getCostPanelTheme('store', mode), [mode]);

  return {
    mode,
    isLight: mode === 'light',
    ui,
    toggleMode,
    setThemeMode,
  };
}
